module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservationGeneral"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("其他预约")]), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em"
    }
  }, [_c('popup-radio', {
    attrs: {
      "title": "预约院区",
      "options": _vm.hospitalOptions
    },
    on: {
      "on-change": _vm.hospitalChoose
    },
    model: {
      value: (_vm.hospital),
      callback: function($$v) {
        _vm.hospital = $$v
      },
      expression: "hospital"
    }
  }), _vm._v(" "), _c('popup-radio', {
    attrs: {
      "readonly": _vm.projectreadonly,
      "title": "预约项目",
      "options": _vm.maxtermOptions
    },
    on: {
      "on-change": _vm.projectChoose
    },
    nativeOn: {
      "click": function($event) {
        _vm.maxtermChooseClick('hospital', '院区')
      }
    },
    model: {
      value: (_vm.maxterm),
      callback: function($$v) {
        _vm.maxterm = $$v
      },
      expression: "maxterm"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": _vm.$route.query.itemid == 'ff80808183c5a6ac0183c627bfdd00c9' ? '登记日期' : '预约日期',
      "is-link": "",
      "value": _vm.date
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateonChange($event)
      }
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": _vm.$route.query.itemid == 'ff80808183c5a6ac0183c627bfdd00c9' ? '登记时段' : '预约时段',
      "is-link": "",
      "value": _vm.time
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateonChange($event)
      }
    }
  }), _vm._v(" "), _c('x-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.injectNumShow),
      expression: "injectNumShow"
    }],
    attrs: {
      "title": "份数",
      "button-style": "round",
      "min": 1
    },
    model: {
      value: (_vm.injectNum),
      callback: function($$v) {
        _vm.injectNum = $$v
      },
      expression: "injectNum"
    }
  }), _vm._v(" "), _c('x-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paralyticSiteShow),
      expression: "paralyticSiteShow"
    }],
    staticClass: "inputClick",
    attrs: {
      "title": "瘫痪部位",
      "text-align": "right",
      "placeholder-align": "right",
      "placeholder": "请输入瘫痪部位"
    },
    model: {
      value: (_vm.paralyticSite),
      callback: function($$v) {
        _vm.paralyticSite = $$v
      },
      expression: "paralyticSite"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 10px 0"
    }
  }, [_c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "border-radius": "25px"
    },
    attrs: {
      "disabled": _vm.submitdisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.submint()
      }
    }
  }, [_vm._v("确认")])], 1), _vm._v(" "), _c('div', {
    staticClass: "softlyFragrant"
  }, [_c('h3', [_vm._v("温馨提示:")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.injectNumShow),
      expression: "!injectNumShow"
    }],
    staticClass: "dectionP"
  }, [_vm._v("\n      1.若不能按时到院可修改预约时间"), _c('br'), _vm._v("\n      2.提前1小时内取消后只能到院预约"), _c('br'), _vm._v("\n      3.连续3次爽约则取消在线预约资格3个月"), _c('br')]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.injectNumShow),
      expression: "injectNumShow"
    }],
    staticClass: "dectionP"
  }, [_vm._v("\n      1.VIP午餐预定必须在下午17:00提前一天预订,且只限定VIP病人预约\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "mask-time",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time-area",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "time-choose-table font13 txt-gray",
    attrs: {
      "id": "time-choose-table"
    }
  }), _vm._v(" "), _c('x-button', {
    staticClass: "am-btn btn-default am-btn-green mt-line btn-choose-time",
    staticStyle: {
      "width": "94.668%",
      "margin-top": "0px"
    }
  }, [_vm._v("确定选择")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-date"
  }, [_c('ul', {
    staticClass: "promptu-menu2 font13"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea2e0b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/MyReservationProject/reservationGeneral.vue
// module id = t7Mi
// module chunks = 5